export const bustlePalette = {
  gold: {
    "50": "#FFFAE8",
    "100": "#FEF0B5",
    "200": "#FDE47C",
    "300": "#F9D03E",
    "400": "#F6C41E",
    "500": "#F3BE10",
    "600": "#F0B80C",
    "700": "#C48F05",
    "800": "#8F6503",
    "900": "#5A3E02",
    "950": "#3A2801",
  },
  blue: {
    "50": "#edf5ff",
    "100": "#ddedff",
    "200": "#c2dcff",
    "300": "#9dc4ff",
    "400": "#77a1ff",
    "500": "#567ffe",
    "600": "#2748f2",
    "700": "#2b44d7",
    "800": "#263cad",
    "900": "#273988",
    "950": "#17204f",
  },
  chalkboard: {
    "50": "#F5F5F5",
    "100": "#E0E0E1",
    "200": "#BBBBBE",
    "300": "#96969B",
    "400": "#737378",
    "500": "#565659",
    "600": "#3E3E42",
    "700": "#313135",
    "800": "#2E2E32",
    "900": "#2C2C30",
    "950": "#2A2A2E",
  },
  forest: {
    "50": "#EDFAF4",
    "100": "#CBF1E1",
    "200": "#97E3C5",
    "300": "#5ECCAB",
    "400": "#32B48C",
    "500": "#1F9269",
    "600": "#1C7C54",
    "700": "#17623F",
    "800": "#104A2E",
    "900": "#0A3120",
    "950": "#061E13",
  },
  lavender: {
    "50": "#F9F5FF",
    "100": "#F0E8FE",
    "200": "#D9BBF9",
    "300": "#C28DF5",
    "400": "#AA60EF",
    "500": "#9034E9",
    "600": "#7520C5",
    "700": "#5C189C",
    "800": "#451274",
    "900": "#2E0C4D",
    "950": "#1B0730",
  },
} as const;
